import { RssService } from './rss.service';

export const rssService = new RssService();
